import { z } from 'zod';

export const SplitsErrors = z.object({
  splits: z.string().nullish(),
});

const SplitsErrorsOptions = SplitsErrors.keyof().options;
export type SplitsErrorKeys = (typeof SplitsErrorsOptions)[number];

type SplitsErrors = (typeof SplitsErrors)['_input'];

export const initialSplitsErrors = () =>
  ({
    splits: null,
  }) satisfies SplitsErrors;
